import React, {useEffect,  useState} from 'react';
import styled from 'styled-components';
import {Dialog} from '@zebra-fed/zds-react-desktop';
import '@zebra-fed/icons/Alert/index.css';
import {useTranslation} from "react-i18next";
import { Item } from '@zebra-fed/zds-react-desktop/components';


const CheckboxComp = styled.div`
    display: flex;
    align-items: center;
    margin-left: -8px;
    font-size: 20px;
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const MainContent = styled.div`
  margin-top: 0;
  display: flex;
  flex-direction: column;
  align-items: inital;
  padding: 20px 20px;
`;

const ButtonContainer = styled.div`
    display: flex;
    max-width: 500px;
    justify-content: end;
`;

export default function ModifyComp(props) {
    const { getAddedNote =()=>{}, clearNote, noteValue, importType } = props;
    const dialogRef = props.modalRef;
    const { t } = useTranslation();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);




    function handleCancel() {
        dialogRef.current.toggleDialog();
        // clearForm();
    }

    const ButtonStyle = {
        cursor: isLoading ? 'wait' : 'pointer',
    }



    const handleChange = (event) => {
        // setImportMethod(event.target.value);
      };

    const onClickContinueBtn =() => {
        // setIsImportTypeSelected(true)
        // setCurrStep(currStep+1)
    }  

    return (
        <div >
            <Dialog 
                ref={dialogRef}
                key='dialog2'
                width='520px'  
                items={[
                   
                    <Item type='button' style={ButtonStyle} 
                    // onClick={handleAddClick} 
                    disabled={isLoading}>{t('continue')}</Item>,
                    <Item type='button' style={{...ButtonStyle, backgroundColor: '#757575', width: '102px'}} 
                    onClick={handleCancel} 
                    disabled={isLoading}>{t("cancel")}</Item>,
                ]}          
               headerStyle={{display: 'none' }}
                bodyStyle={{padding: '0px', width: '100%'}}
                cardStyle={{ marginBottom: '80px'}}
                style={{cursor: isLoading ? 'wait' : 'default'}}>
                <ModalHeader>
                   {importType?.name}
                </ModalHeader>
                <MainContent>
                            <p>this is modify page</p>
                </MainContent>
                {/* <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
                    <SnackbarContent error={true}>{serverMessage.current}</SnackbarContent>
                </Snackbar> */}
            </Dialog>
        </div>
    )
}